const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
    <div className="text-center">
      <h1 className="text-6xl font-bold text-gray-800 dark:text-white mb-4">404</h1>
      <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">Page Not Found</p>
      <a href="/" className="px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white rounded-lg transition-colors">Go to Dashboard</a>
    </div>
  </div>
);
export default NotFound;
